<template>
    <div>
        <div v-if="status == 0">
            Mengambil data barang, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data barang.
        </div>
        <div v-else-if="status == 1">
            <h3 class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
            {{ data.kind }} - {{ data.brand }}
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="6">
                    <strong>IMEI / SN</strong><br />
                    {{ data.imei_sn || "-" }}
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>Tanggal Request</strong><br />
                    {{ data.created_at || "-" }}
                </b-col>
                <b-col md="6">
                    <strong>Note Request</strong><br />
                    {{ data.request_note || "-" }}
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>Tanggal Proses</strong><br />
                    {{ data.processed_at || "-" }}
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>Tanggal Batal</strong><br />
                    {{ data.cancel_at || "-" }}
                </b-col>
                <b-col md="6">
                    <strong>Note Batal</strong><br />
                    {{ data.cancel_note || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-4 mb-2">
                <b-col class="text-right">
                    <b-button variant="primary" @click="confirmAdd">
                        <i class="fa fa-check mr-2" />Lanjutkan
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <b-modal id="m-confirm" title="Konfirmasi" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Konfirmasi penambahan barang ini kedalam invoice batal pengembalian.
            <b-row class="mt-4">
                <b-col>
                    <h3 class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
                    {{ data.kind }} - {{ data.brand }}
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="6">
                    <strong>IMEI / SN</strong><br />
                    {{ data.imei_sn || "-" }}
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>Tanggal Request</strong><br />
                    {{ data.created_at || "-" }}
                </b-col>
                <b-col md="6">
                    <strong>Note Request</strong><br />
                    {{ data.request_note || "-" }}
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>Tanggal Proses</strong><br />
                    {{ data.processed_at || "-" }}
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-2">
                <b-col md="6">
                    <strong>Tanggal Batal</strong><br />
                    {{ data.cancel_at || "-" }}
                </b-col>
                <b-col md="6">
                    <strong>Note Batal</strong><br />
                    {{ data.cancel_note || "-" }}
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execAddItem">
                    {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        noFaktur: { type: String, required: true },
        cancelReturnInvoiceId: { type: Number, required: true }
    },
    data() {
        return {

            status: 0, // 0: loading, 1: success, -1: fail
            isSubmitting: false,

            data: {},

            items: []

        }
    },
    methods: {

        init() {

            this.status = 0
            let payload = {
                no_faktur_pgi: this.noFaktur,
                cancel_return_invoice_id: this.cancelReturnInvoiceId
            }

            this.$axios.post("inventory-return-cancel-pgi/get-return-item", payload).then(res => {

                let data = res.data.data
                this.data = data

                this.status = 1

            })
            .catch(error => {

                this.$helper.parseError(this, error)
                this.status = -1

            })

        },

        confirmAdd() {

            this.$bvModal.show("m-confirm")

        },

        execAddItem() {

            let payload = {
                no_faktur_pgi: this.noFaktur,
                cancel_return_invoice_id: this.cancelReturnInvoiceId
            }

            this.isSubmitting = true
            this.$axios.post("inventory-return-cancel-pgi/add-item-return-cancel-invoice", payload).then(res => {

                this.$bvModal.hide("m-confirm")
                this.$emit("item-added", "Barang berhasil ditambahkan!")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    },
    created() {
        this.init()
    }
}
</script>
